import { Leaf, Sprout } from 'lucide-react';

export const BLADES = "M0 40 L6 18 L11 40 L17 8 L23 40 L29 16 L35 4 L43 40 L50 12 L57 40 L64 20 L72 6 L80 40 L88 16 L96 40 L104 10 L112 40 L120 22 L128 40 L136 8 L144 40 L152 18 L160 4 L168 40 L176 14 L184 40 L192 22 L200 6 L208 40 L216 16 L224 40 L232 10 L240 40 L248 20 L256 40 L264 8 L272 40 L280 18 L288 4 L296 40 L304 12 L312 40 L320 22 L328 6 L336 40 L344 18 L352 40 L360 8 L368 40 L376 16 L384 40 L392 24 L400 4 L408 40 L416 14 L424 40 L432 20 L440 6 L448 40 L456 18 L464 40 L472 10 L480 40 L488 22 L496 40 L504 8 L512 40 L520 16 L528 4 L536 40 L544 12 L552 40 L560 20 L568 6 L576 40 L584 18 L592 40 L600 12 L600 40 Z";

export const GrassDivider = ({ color }) => (
  <div
    aria-hidden="true"
    className="absolute bottom-0 left-0 right-0 h-8 md:h-10 pointer-events-none"
    style={{
      backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 40' preserveAspectRatio='none' width='600' height='40'><path d='${BLADES}' fill='${encodeURIComponent(color)}'/></svg>")`,
      backgroundRepeat: 'repeat-x',
      backgroundPosition: 'bottom',
      backgroundSize: '600px 100%',
    }}
  />
);

export const SectionDecor = ({ flip = false }) => (
  <div aria-hidden="true" className="absolute inset-0 pointer-events-none overflow-hidden">
    <Leaf className={`absolute ${flip ? 'left-[-30px]' : 'right-[-30px]'} top-8 w-32 h-32 md:w-48 md:h-48 text-green-600/10 ${flip ? '-rotate-12' : 'rotate-45'}`} strokeWidth={1.2} />
    <Leaf className={`absolute ${flip ? 'left-24 md:left-40' : 'right-24 md:right-44'} top-24 w-10 h-10 md:w-14 md:h-14 text-lime-600/15 ${flip ? 'rotate-90' : '-rotate-45'}`} strokeWidth={1.5} />
    <Sprout className={`absolute ${flip ? 'right-6 md:right-16' : 'left-6 md:left-16'} bottom-12 w-20 h-20 md:w-28 md:h-28 text-green-700/10`} strokeWidth={1.2} />
  </div>
);
